var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"unauthorized"},[_c('b-row',[_c('h2',[_vm._v("Unauthorized")])]),_c('b-img',{attrs:{"center":"","src":"https://whatsticker.online/stickers_asset/ws-pack-36/c1eae0c4c5-1010.png","width":"300"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }